export const KEY_ACCOUNT_LOGIN_FETCH = 'KEY_ACCOUNT_LOGIN_FETCH';
export interface FetchLogin {
  type: typeof KEY_ACCOUNT_LOGIN_FETCH;
  payload: {
    email?: string;
    password: string;
    phone?: string;
  };
}

export const KEY_ACCOUNT_LOGIN_INCORRECT = 'KEY_ACCOUNT_LOGIN_INCORRECT';
export interface HandleIncorrect {
  type: typeof KEY_ACCOUNT_LOGIN_INCORRECT;
  payload: {
    message: string;
  };
}

export const KEY_ACCOUNT_VALIDATE_PHONE_OTP_UPDATE_PROFILE =
  'KEY_ACCOUNT_VALIDATE_PHONE_OTP_UPDATE_PROFILE';
export interface ValidatePhoneOtpUpdateProfile {
  type: typeof KEY_ACCOUNT_VALIDATE_PHONE_OTP_UPDATE_PROFILE;
  payload: {
    phoneSessionId: string;
    otp: string;
    email: string;
    password: string;
  };
}

export const KEY_ACCOUNT_VALIDATE_EMAIL_OTP_UPDATE_PROFILE =
  'KEY_ACCOUNT_VALIDATE_EMAIL_OTP_UPDATE_PROFILE';
export interface ValidateEmailOtpUpdateProfile {
  type: typeof KEY_ACCOUNT_VALIDATE_EMAIL_OTP_UPDATE_PROFILE;
  payload: {
    emailSessionId: string;
    otp: string;
    email: string;
    password: string;
    userId?: string;
  };
}

export const KEY_ACCOUNT_LOGIN_CLEAR = 'KEY_ACCOUNT_LOGIN_CLEAR';
export interface ClearLogin {
  type: typeof KEY_ACCOUNT_LOGIN_CLEAR;
  payload?: undefined;
}

export const KEY_ACCOUNT_REGISTER_CLEAR = 'KEY_ACCOUNT_REGISTER_CLEAR';
export interface ClearRegister {
  type: typeof KEY_ACCOUNT_REGISTER_CLEAR;
}

export const KEY_ACCOUNT_EMAIL_AVAILABILITY = 'KEY_ACCOUNT_EMAIL_AVAILABILITY';
export interface EmailCheck {
  type: typeof KEY_ACCOUNT_EMAIL_AVAILABILITY;
  payload: {
    email: string;
  };
}

export const KEY_ACCOUNT_EMAIL_AVAILABILIT_SUCCESS = 'KEY_ACCOUNT_EMAIL_AVAILABILITY_SUCCESS';
export interface EmailCheckSuccess {
  type: typeof KEY_ACCOUNT_EMAIL_AVAILABILIT_SUCCESS;
  payload?: {
    message: string;
  };
}

export const KEY_ACCOUNT_EMAIL_AVAILABILIT_FAILED = 'KEY_ACCOUNT_EMAIL_AVAILABILITY_FAILED';
export interface EmailCheckFailed {
  type: typeof KEY_ACCOUNT_EMAIL_AVAILABILIT_FAILED;
  payload: {
    message: string;
  };
}

export const KEY_ACCOUNT_PHONE_AVAILABILITY = 'KEY_ACCOUNT_PHONE_AVAILABILITY';
export interface PhoneCheck {
  type: typeof KEY_ACCOUNT_PHONE_AVAILABILITY;
  payload: {
    phoneNumber: string;
  };
}

export const KEY_ACCOUNT_PHONE_AVAILABILIT_SUCCESS = 'KEY_ACCOUNT_PHONE_AVAILABILITY_SUCCESS';
export interface PhoneCheckSuccess {
  type: typeof KEY_ACCOUNT_PHONE_AVAILABILIT_SUCCESS;
  payload?: {
    message: string;
  };
}

export const KEY_ACCOUNT_PHONE_AVAILABILIT_FAILED = 'KEY_ACCOUNT_PHONE_AVAILABILITY_FAILED';
export interface PhoneCheckFailed {
  type: typeof KEY_ACCOUNT_PHONE_AVAILABILIT_FAILED;
  payload: {
    message: string;
  };
}

export const KEY_ACCOUNT_SET_DATAFORM = 'KEY_ACCOUNT_SET_DATAFORM';
export interface SetDataForm {
  type: typeof KEY_ACCOUNT_SET_DATAFORM;
  payload: {
    firstName?: string;
    lastName?: string;
    email?: string;
    password?: string;
    phoneNumber?: string;
    username: string;
  };
}

export const KEY_ACCOUNT_TOGGLE_POPUP = 'KEY_ACCOUNT_TOGGLE_POPUP';
export interface ToggleCondition {
  type: typeof KEY_ACCOUNT_TOGGLE_POPUP;
  payload?: undefined;
}

export const KEY_ACCOUNT_PASSWORDRESET_POPUP = 'KEY_ACCOUNT_PASSWORDRESET_POPUP';
export interface TogglePasswordReset {
  type: typeof KEY_ACCOUNT_PASSWORDRESET_POPUP;
  payload?: undefined;
}

export const KEY_ACCOUNT_POPUP_CLEAR = 'KEY_ACCOUNT_POPUP_CLEAR';
export interface PopupClear {
  type: typeof KEY_ACCOUNT_POPUP_CLEAR;
}

export const KEY_ACCOUNT_GEN_OTP = 'KEY_ACCOUNT_GEN_OTP';
export interface GenOtp {
  type: typeof KEY_ACCOUNT_GEN_OTP;
  payload: {
    type: string;
    email?: string;
    phoneNumber?: string;
  };
}

export const KEY_ACCOUNT_SET_EMAIL_SESSION = 'KEY_ACCOUNT_SET_EMAIL_SESSION';
export interface SetEmailSession {
  type: typeof KEY_ACCOUNT_SET_EMAIL_SESSION;
  payload: {
    emailRef: string;
    emailSessionId: string;
  };
}

export const KEY_ACCOUNT_VALIDATE_EMAIL_OTP = 'KEY_ACCOUNT_VALIDATE_EMAIL_OTP';
export interface ValidateEmailOtp {
  type: typeof KEY_ACCOUNT_VALIDATE_EMAIL_OTP;
  payload: {
    email?: string;
    password?: string;
    firstName?: string;
    lastName?: string;
    username: string;
    emailSessionId?: string;
    otp: string;
    phoneNumber?: string;
    phoneSessionId?: string;
  };
}

export const KEY_ACCOUNT_VALIDATE_EMAIL_OTP_SUCCESS = 'KEY_ACCOUNT_VALIDATE_EMAIL_OTP_SUCCESS';
export interface ValidateEmailSuccess {
  type: typeof KEY_ACCOUNT_VALIDATE_EMAIL_OTP_SUCCESS;
}

export const KEY_ACCOUNT_VALIDATE_EMAIL_OTP_FAILED = 'KEY_ACCOUNT_VALIDATE_EMAIL_OTP_FAILED';
export interface ValidateEmailFailed {
  type: typeof KEY_ACCOUNT_VALIDATE_EMAIL_OTP_FAILED;
}

export const KEY_ACCOUNT_SET_PHONE_SESSION = 'KEY_ACCOUNT_SET_PHONE_SESSION';
export interface SetPhoneSession {
  type: typeof KEY_ACCOUNT_SET_PHONE_SESSION;
  payload: {
    phoneRef: string;
    phoneSessionId: string;
  };
}

export const KEY_ACCOUNT_VALIDATE_PHONE_OTP = 'KEY_ACCOUNT_VALIDATE_PHONE_OTP';
export interface ValidatePhoneOtp {
  type: typeof KEY_ACCOUNT_VALIDATE_PHONE_OTP;
  payload: {
    password?: string;
    phone?: string;
    firstName?: string;
    lastName?: string;
    username: string;
    sessionId: string;
    otp: string;
  };
}

export const KEY_ACCOUNT_VALIDATE_PHONE_OTP_SUCCESS = 'KEY_ACCOUNT_VALIDATE_PHONE_OTP_SUCCESS';
export interface ValidatePhoneSuccess {
  type: typeof KEY_ACCOUNT_VALIDATE_PHONE_OTP_SUCCESS;
}

export const KEY_ACCOUNT_VALIDATE_PHONE_OTP_FAILED = 'KEY_ACCOUNT_VALIDATE_PHONE_OTP_FAILED';
export interface ValidatePhoneFailed {
  type: typeof KEY_ACCOUNT_VALIDATE_PHONE_OTP_FAILED;
}

export interface CreateUser {
  email?: string;
  password?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  username: string;
  emailSessionId?: string;
  phoneSessionId?: string;
}

export const KEY_ACCOUNT_CREATE_SUCCESS = 'KEY_ACCOUNT_CREATE_SUCCESS';
export interface CreateSuccess {
  type: typeof KEY_ACCOUNT_CREATE_SUCCESS;
}

export const KEY_ACCOUNT_CREATE_FAILED = 'KEY_ACCOUNT_CREATE_FAILED';
export interface CreateFailed {
  type: typeof KEY_ACCOUNT_CREATE_FAILED;
}

export const KEY_ACCOUNT_PASSWORDRESET_OTP_SUCCESS = 'KEY_ACCOUNT_PASSWORDRESET_OTP_SUCCESS';
export interface PasswordResetOtpSuccess {
  type: typeof KEY_ACCOUNT_PASSWORDRESET_OTP_SUCCESS;
  payload: string;
}

export const KEY_VALIDATE_INVITE_EMAIL = 'KEY_VALIDATE_INVITE_EMAIL';
export interface ValidateInviteEmail {
  type: typeof KEY_VALIDATE_INVITE_EMAIL;
  payload: string;
}

export const KEY_GEN_INVITE_OTP = 'KEY_GEN_INVITE_OTP';
export interface GenerateInviteOTP {
  type: typeof KEY_GEN_INVITE_OTP;
}

export const KEY_INVITEE_REGISTERED = 'KEY_INVITEE_REGISTERED';
export interface InviteeRegistered {
  type: typeof KEY_INVITEE_REGISTERED;
}

export const KEY_USER_UPDATE_INVITE = 'KEY_USER_UPDATE_INVITE';
export interface UserUpdateInvite {
  type: typeof KEY_USER_UPDATE_INVITE;
}

export const KEY_VALIDATE_INVITE_PHONE = 'KEY_VALIDATE_INVITE_PHONE';
export interface ValidateInvitePhone {
  type: typeof KEY_VALIDATE_INVITE_PHONE;
  payload: string;
}

export const KEY_CLEAR_AVAILABLE_STATUS = 'KEY_CLEAR_AVAILABLE_STATUS';
export interface ClearAvailableStatus {
  type: typeof KEY_CLEAR_AVAILABLE_STATUS;
}

export type AccountType =
  | FetchLogin
  | HandleIncorrect
  | ClearLogin
  | ClearRegister
  | ToggleCondition
  | TogglePasswordReset
  | PopupClear
  | EmailCheck
  | EmailCheckSuccess
  | EmailCheckFailed
  | PhoneCheck
  | PhoneCheckSuccess
  | PhoneCheckFailed
  | SetDataForm
  | GenOtp
  | SetEmailSession
  | ValidateEmailOtp
  | ValidateEmailSuccess
  | ValidateEmailFailed
  | ValidatePhoneOtpUpdateProfile
  | ValidateEmailOtpUpdateProfile
  | SetPhoneSession
  | ValidatePhoneOtp
  | ValidatePhoneSuccess
  | ValidatePhoneFailed
  | CreateSuccess
  | CreateFailed
  | PasswordResetOtpSuccess
  | ValidateInviteEmail
  | GenerateInviteOTP
  | ValidateInvitePhone
  | InviteeRegistered
  | ClearAvailableStatus
  | UserUpdateInvite;
